// extracted by mini-css-extract-plugin
export default {"header-search-bar-suggestions-column":"header-search-bar-suggestions-column_TFn37yc6"};